// src/components/ExpertSelector.js
import React, { useState } from 'react';
import './ExpertSelector.css';

const ExpertSelector = ({ onSelectExpert, selectedExpert, disabled }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const experts = [
        {
            id: 'SecurityExpert',
            name: 'Security Expert',
            icon: '🛡️',
            description: 'Cybersecurity incident analysis, threat detection, and vulnerability assessment',
            color: '#dc3545'
        },
        {
            id: 'TechnicalIncidentExpert',
            name: 'Technical Incident Expert',
            icon: '⚙️',
            description: 'System failures, performance issues, and technical root cause analysis',
            color: '#17a2b8'
        },
        {
            id: 'DevOpsExpert',
            name: 'DevOps Expert',
            icon: '🚀',
            description: 'CI/CD pipeline issues, deployment failures, and infrastructure incidents',
            color: '#28a745'
        },
        {
            id: 'ComplianceExpert',
            name: 'Compliance Expert',
            icon: '📋',
            description: 'Regulatory compliance, audit findings, and policy violations',
            color: '#ffc107'
        },
        {
            id: 'CustomerSupportExpert',
            name: 'Customer Support Expert',
            icon: '💬',
            description: 'Customer-reported issues, support ticket analysis, and user experience incidents',
            color: '#6f42c1'
        },
        {
            id: 'RiskIntelligenceExpert',
            name: 'Risk Intelligence Expert',
            icon: '🎯',
            description: 'Risk assessment, threat intelligence, and proactive incident prevention',
            color: '#fd7e14'
        }
    ];

    const getSelectedExpertName = () => {
        const expert = experts.find(e => e.id === selectedExpert);
        return expert ? expert.name : 'Select Analysis Expert';
    };

    const getSelectedExpertIcon = () => {
        const expert = experts.find(e => e.id === selectedExpert);
        return expert ? expert.icon : '🎯';
    };

    return (
        <div className={`expert-selector-wrapper ${isExpanded ? 'expanded' : ''}`}>
            <div className="expert-selector-header">
                <button
                    className={`expert-toggle-btn ${isExpanded ? 'active' : ''}`}
                    onClick={() => setIsExpanded(!isExpanded)}
                    disabled={disabled}
                >
                    <span className="toggle-icon">{isExpanded ? '▼' : '▶'}</span>
                    <span className="expert-badge">
                        <span className="expert-badge-icon">{getSelectedExpertIcon()}</span>
                        <span className="expert-badge-text">{getSelectedExpertName()}</span>
                    </span>
                    <span className="expert-status">
                        {selectedExpert && <span className="status-indicator" />}
                    </span>
                </button>
            </div>

            {isExpanded && (
                <div className="expert-selector-content">
                    <div className="expert-header">
                        <h3>🎯 Choose Your Analysis Expert</h3>
                        <p>Select a specialized AI expert for your incident analysis</p>
                    </div>
                    <div className="expert-buttons">
                        {experts.map((expert) => (
                            <button
                                key={expert.id}
                                className={`expert-btn ${selectedExpert === expert.id ? 'active' : ''}`}
                                onClick={() => {
                                    onSelectExpert(expert.id);
                                    setIsExpanded(false); // Optional: collapse after selection
                                }}
                                disabled={disabled}
                                style={{
                                    '--expert-color': expert.color
                                }}
                            >
                                <div className="expert-icon">{expert.icon}</div>
                                <div className="expert-content">
                                    <div className="expert-name">{expert.name}</div>
                                    <div className="expert-description">{expert.description}</div>
                                </div>
                                {selectedExpert === expert.id && (
                                    <div className="expert-check">✓</div>
                                )}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ExpertSelector;